import { TranslationMap } from '@trimble-gcs/i18n-types';

export function tabHostTranslations() {
  return {
    mapView: {
      tooltip: {
        text: $localize`:@@tabHost.mapView.tooltip:Map View`,
        desc:
          "Tooltip for the 'Map View' button on the app toolbar. " +
          'The Map View displays a two-dimensional world map with pins ' +
          'at the geographical locations of datasets in the project.',
      },
    },
    listView: {
      tooltip: {
        text: $localize`:@@tabHost.listView.tooltip:List View`,
        desc:
          'Tooltip for the List View button on the app toolbar. ' +
          'The List View displays datasets in the project as a tabular listing.',
      },
    },
    view3d: {
      tooltip: {
        text: $localize`:@@tabHost.view3d.tooltip:View in 3D`,
        desc:
          'Tooltip for the 3D View button. ' +
          'The button navigates to a viewer with a three-dimensional display of spatial data.',
      },
      button: {
        text: $localize`:@@tabHost.view3d.button:3D`,
        desc:
          'Text for the 3D View button. ' +
          'The button navigates to a viewer with a three-dimensional display of spatial data.',
        limit: 4,
      },
    },
    viewInNumark: {
      tooltip: {
        text: $localize`:@@tabHost.viewInNumark.tooltip:View in Multi-pane`,
        desc:
          'Tooltip for the View in Numark button. ' +
          "The button navigates to the Numark application to view spatial data. The term 'Multi-pane' is a brand name and not translated.",
      },
    },
    search: {
      placeholder: {
        text: $localize`:@@tabHost.search.placeholder:Find`,
        desc:
          'Placeholder text for the search input. ' +
          'The search functionaity allows users to do a text search of their data.',
      },
    },
    filter: {
      tooltip: {
        text: $localize`:@@tabHost.filter.tooltip:Filter`,
        desc:
          "Tooltip for the 'Filter' button. " +
          'Clicking the button opens a panel that allow the user to filter their data ' +
          'by selecting various filter criteria.',
      },
    },
    download: {
      tooltip: {
        text: $localize`:@@tabHost.download.tooltip:Download Status`,
        desc:
          "Tooltip for the 'Download Status' button. " +
          'The button opens a panel that displays the status of one or more files ' +
          "that are being downloaded or has completed downloading to the user's local file system.",
      },
    },
    reload: {
      tooltip: {
        text: $localize`:@@tabHost.reload.tooltip:Reload Project Data`,
        desc:
          "Tooltip for the 'Reload' button. " +
          'The button reloads the data in the project from the server and refreshes the current view.',
      },
    },
    settings: {
      tooltip: {
        text: $localize`:@@tabHost.settings.tooltip:Settings`,
        desc:
          "Tooltip for the 'Settings' button. " +
          'The button navigates to a view that allows the user to change application settings.',
      },
    },
    import: {
      button: {
        text: $localize`:@@tabHost.import.button:Import`,
        desc:
          "Text for the 'Import' button. " +
          'The button opens a dialog that allows the import of data into the project.',
      },
    },
  } satisfies TranslationMap;
}
